<template lang="html">

  <div class="candidaturas-view" v-if="!loading">

    <h2 v-if="esHome">{{$t('encabezado.actualidad')}}</h2>
    <encabezado :data="'actualidad'" v-else></encabezado>

    <div class="btn-not-container">
      <button class="btn" :class="[mostrarNoticias ? '-solid-primary' : '-skull-primary']" @click="mostrarNoticiasClicked">{{$t('encabezado.noticias')}}</button>
      <button class="btn" :class="[mostrarNovedades ? '-solid-primary' : '-skull-primary']" @click="mostrarNovedadesClicked">{{$t('encabezado.novedades')}}</button>
    </div>

    <div class="row cont-recurso" v-if="lRecursosFilter.length>0" >
      <template v-for="(recurso, key) in lRecursosFilter" style="margin:15px;">
        <actualidad-el :data="recurso"></actualidad-el>
      </template>
      <div class="row ver-mas-cont" v-if="esHome">
        <arrow-link class="arrow-link" :text="$t('ver_mas')" :to="$t('enlaces.actualidad')" :external="false" :blank="false">
        </arrow-link>
      </div>
    </div>
    <h1 class="row cont-recurso" style="display:block;text-align:center;" v-else >
      {{$t('encabezado.no_actualidad')}}
    </h1>

  </div>

  <loading v-else-if="!esHome"></loading>

</template>

<script lang="js">

  import encabezado from '@/components/parts/encabezado';

  import {mapGetters, mapActions} from 'vuex';

  import loadingView from '@/components/parts/loading';

  import router from '@/router';

  import actualidadEl from '@/components/views/noticias/actualidad-el'
  
  import arrowLink from '@/components/parts/icons/arrow-link';
  
  export default  {
    name: 'actualidad',
    props :['esHome'],
    components : {
      'encabezado' : encabezado,
      'loading' : loadingView,
      'actualidad-el' : actualidadEl,
      'arrow-link': arrowLink,
    },
    mounted(){
      this.getActualidad(this.isEmpresa).then(r => {
        this.lRecursos = r;
        this.loading = false;
      })
    },
    data(){
      return {
        loading: true,
        mostrarNoticias: false,
        mostrarNovedades: false,
        lRecursos: [],
      }
    },
    methods: {
      ...mapActions([
        'getActualidad'
      ]),
      mostrarNoticiasClicked: function(){
        this.mostrarNoticias=!this.mostrarNoticias;
      },
      mostrarNovedadesClicked: function(){
        this.mostrarNovedades=!this.mostrarNovedades;
      }
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
        isEmpresa : 'isEmpresa',
      }),
      lRecursosFilter : function(){
        if (this.lRecursos!=null && this.lRecursos.length>0){
          if (this.esHome) {
            return this.lRecursos.filter((r) => (r.Tipo == 'noticia' && this.mostrarNoticias) || (r.Tipo == 'novedad' && this.mostrarNovedades) || (!this.mostrarNoticias && !this.mostrarNovedades)).slice(0, 3);
          }else{
            return this.lRecursos.filter((r) => (r.Tipo == 'noticia' && this.mostrarNoticias) || (r.Tipo == 'novedad' && this.mostrarNovedades) || (!this.mostrarNoticias && !this.mostrarNovedades));
          }
        }else{
          return [];
        }
      }
    },
  }
</script>

<style scoped lang="scss">

  .candidaturas-view{
    width: 100%
  }

  h2{
    font-weight: 800;
    width: 100%;
    font-size: 36px;
    margin-top: 100px;
    color: #ff5700;
  }

  .row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .col-lg-4, .col-sm-6{
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }
  @media (min-width: 576px) {
    .col-sm-6 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
  @media (min-width: 992px) {
    .col-lg-4 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
  }
  
  .selector-tipo{
    margin-top: 50px;
  }

  .wrapper-filtro{
    margin-bottom: 0;
  }

  .status{
    border: none;
    outline: none;
    background-color: transparent;
    padding-left: 0;
    height: 30px;
    line-height: 30px;
    font-weight: 700;
    margin: 0 25px;
    cursor:pointer;
    opacity: .7;
  }

  .status[active="true"]{
    text-decoration: underline;
    opacity: 1;
  }

  @media screen and (max-width: 767px){

    .selector-tipo{
      margin-top: 25px;
    }

    .selector-tipo a{
      border-right: none;
      padding-right: 5px;
      margin-right: 5px;
      font-size: 12px;
    }


  }


  @media screen and (max-width: 380px){
    .selector-tipo a{
      padding-right: 3px;
      margin-right: 3px;
      font-size: 12px;
    }
  }


  @media screen and (max-width: 330px){
    .selector-tipo a{
      padding-right: 4px;
      margin-right: 4px;
      font-size: 10px;
    }
  }

  @media screen and (max-width: 500px){
    .status{
      margin: 0 10px;
    }
  }

  .btn-not-container{
    margin: 40px;
  }

  .-skull-primary{
    height: 43px;
    width: 156px;
  }

  .-solid-primary{
    height: 40px;
    width: 160px;
  }

  .cont-recurso{
    margin: 60px 200px;

    .ver-mas-cont{
      width: 100%;
      display: inline;
      text-align: center;

      .arrow-link{
        width: 100px;
        left: 48%;
        top: 25px;
        position: relative;
      }
    }
  }  

  @media screen and (max-width: 1200px){
    .cont-recurso{
      margin: 60px 40px;
    }
  }  

</style>



// WEBPACK FOOTER //
// src/components/views/noticias/actualidad.vue